export const JANUS_OAB_FALLBACK_URL = 'https://oab.damasio.com.br/';

// Requests a one-time SSO redirect URL for the Janus/Damásio OAB platform.
// Returns the signed redirect URL on success, or JANUS_OAB_FALLBACK_URL when the
// request fails or the payload is missing, so the caller can always navigate
// somewhere sensible. Errors are reported to Rollbar for observability.
export async function fetchJanusOabRedirectUrl(
  questionId = null,
  answer = null,
  sourceUrl = null
) {
  try {
    const payload = {};

    if (questionId) {
      payload.question_id = questionId;
    }

    if (answer) {
      payload.answer = answer;
    }

    if (sourceUrl) {
      payload.source_url = sourceUrl;
    }

    const response = await fetch('/api/user/auth/janus_oab', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document
          .querySelector('meta[name="csrf-token"]')
          ?.getAttribute('content')
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      return JANUS_OAB_FALLBACK_URL;
    }

    if (!data.redirect_url) {
      return JANUS_OAB_FALLBACK_URL;
    }

    return data.redirect_url;
  } catch (err) {
    Rollbar.error('Erro ao gerar redirect Janus OAB', err);
    return JANUS_OAB_FALLBACK_URL;
  }
}
